/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */

import { modules } from "byzantine";
import { memo, useEffect, useState } from "react";
import { ScrollingIframe } from "cerulean";

const ZEscrow = () => {
  const { fetchHTML } = modules.zescrow.useFetchZEscrowHTML();

  const [htmlBlock, setHtmlBlock] = useState<string>();

  useEffect(() => {
    fetchHTML({
      onData: ({ zescrow_form }) => {
        const html = atob(zescrow_form);
        setHtmlBlock(html);
      },
    });
  }, []);

  return <ScrollingIframe title="ZEscrow" srcDoc={htmlBlock} />;
};

export default memo(ZEscrow);
